// Dominio de producción. Meta Pixel y las conversiones de Google Ads SOLO se
// activan aquí. GA4 recibe eventos en todos los entornos (local, preview y
// producción), distinguidos con la dimensión "Entorno" — es la herramienta
// para probar eventos fuera de producción.
//
// - Meta Pixel y conversiones de Google Ads solo se activan en dashboard.zyrapp.com.
//   En local o en preview el píxel no se carga: es intencionado, no un error.
// - Para probar eventos de Meta, hay que hacerlo en producción con un email
//   identificable, e indicar el email y la hora de la prueba.
// - El envío a GA4 no depende de isProductionHost() y no cambia.
export const PROD_HOST = 'dashboard.zyrapp.com'

export function isProductionHost(): boolean {
  return window.location.hostname === PROD_HOST
}
